import { BugsWrapper } from '@tools/bugs/Bugs';
import { Bugsnag } from '@tools/bugs/Bugsnag';

export const Bugs = new BugsWrapper(Bugsnag);
